import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({ name: 'safeHtml' })
export class SanitizerPipe implements PipeTransform {
    constructor(private _sanitizer: DomSanitizer) { }

    transform(value: any, type: string) {
        const sanitizedContent = DOMPurify.sanitize(value);
        return this._sanitizer.bypassSecurityTrustHtml(sanitizedContent);

    }
}
